const VOUCHER_THEME_TITLE_COLOUR_MAP: Record<string, App.Design.ContentColour> = {
  luxplus: 'lux-plus',
  societe: 'neutral-one',
}

export default function getVoucherTitleColour(theme?: string): App.Design.ContentColour {
  if (theme && theme in VOUCHER_THEME_TITLE_COLOUR_MAP) {
    return VOUCHER_THEME_TITLE_COLOUR_MAP[theme]
  }
  return 'neutral-two'
}
